import ky from "ky";

const apiClient = ky.create({
  prefixUrl: "https://email-worker.eric-naonow.workers.dev/",
});

export const sendEmail = async (email: string) => {
  const response = await apiClient.post("api/contact-form", {
    json: { email },
    mode: "cors",
  });
  return response.text();
};
